import { UnexpectedError } from '@adv-frontend/error';
import { stringifyFieldIdPath } from '../../fields/utils/stringifyFieldIdPath';
import { FormSliceState } from '../types';

/**
 * Преобразует path в fieldId (обратная операция к getFieldPathById)
 *
 * @param fieldsStateGetter - функция для получения состояния полей
 * @param path - массив строк, представляющий путь к полю (например, ["user", "addresses", "0", "street"])
 * @returns строка fieldId (например, "user.addresses.ARRAY_ITEM_ID_1.street")
 *
 * @example
 * getFieldIdByPath(() => fieldsState, ["user", "name"]) // "user.name"
 * getFieldIdByPath(() => fieldsState, ["array", "0", "value"]) // "array.ARRAY_ITEM_ID_1.value"
 */
export function getFieldIdByPath(
    fieldsStateGetter: () => FormSliceState['forms'][string]['fieldsState'],
    path: string[]
): string {
    if (path.length === 0) {
        return '';
    }

    const fieldsState = fieldsStateGetter();
    const fieldIdPath: string[] = [];

    for (const segment of path) {
        // Проверяем, является ли родительское поле массивом (имеет order)
        const currentFieldId = stringifyFieldIdPath(fieldIdPath);
        const fieldState = fieldsState[currentFieldId];

        if (fieldState && 'order' in fieldState) {
            // Родительское поле - массив, значит текущий segment - это индекс
            const index = parseInt(segment, 10);
            const arrayItemId = fieldState.order[index];

            if (arrayItemId) {
                // Извлекаем только ID элемента массива (убираем префикс пути)
                const arrayItemIdParts = arrayItemId.split('.');
                const itemId = arrayItemIdParts[arrayItemIdParts.length - 1];
                if (itemId) {
                    fieldIdPath.push(itemId);
                } else {
                    console.warn(
                        new UnexpectedError('Отсутствует itemid в arrayItemId', {
                            cause: null,
                            additional: {
                                arrayItemId,
                                fieldIdPath,
                            },
                        })
                    );
                }
            } else {
                console.warn(
                    new UnexpectedError('Не нашли arrayItemId для элемента', {
                        cause: null,
                        additional: {
                            index,
                            currentFieldId,
                            fieldStateOrder: JSON.stringify(fieldState.order),
                        },
                    })
                );
            }
        } else {
            // Обычное поле объекта
            fieldIdPath.push(segment);
        }
    }

    return stringifyFieldIdPath(fieldIdPath);
}
